import { Typography, Stack } from '@mui/material';

import { EmptyDate } from 'Input/EmptyDate';
import { useInputStore } from 'Store';

const DateEmpty = () => {

  const min_date = useInputStore(state => state.sim_start_date)
  const max_date = useInputStore(state => state.sim_end_date)
 
  return (
    <Stack spacing={1}>
      <Typography variant='body1' component='h1' textAlign='center'>
      A date when you might plan to empty your slurry store.
      We'll revisit this later to explore emptying dates that help reduce total methane emissions over the selected time period. 
      </Typography>
    <>
      <EmptyDate min_date={min_date} max_date={max_date} />
    </>
    </Stack>
  );
}

export default DateEmpty;
